import {
  AGE_GATE_QUERY_KEY,
  DRAFT_QUERY_KEY,
  SELECT_STORE_QUERY_KEY,
  STORE_ID_QUERY_KEY,
} from '@jane/bloom/utils/queryParams/queryParams';

interface QueryStringContainingArgs {
  paramKeys?: string[];
  prefix?: '?' | '&';
  searchParams: URLSearchParams;
}

export const queryStringContaining = ({
  paramKeys = [
    AGE_GATE_QUERY_KEY,
    DRAFT_QUERY_KEY,
    SELECT_STORE_QUERY_KEY,
    STORE_ID_QUERY_KEY,
  ],
  prefix = '?',
  searchParams,
}: QueryStringContainingArgs) => {
  const preservedSearchParams = new URLSearchParams();
  paramKeys.forEach((key) => {
    const val = searchParams.get(key) ?? '';
    if (val) {
      preservedSearchParams.set(key, val);
    }
  });

  return preservedSearchParams.size === 0
    ? ''
    : `${prefix}${preservedSearchParams}`;
};

/**
 * Returns a query string containing the same values as the given query params from the original request.
 */
export function preservingQueryParams(
  request: Request,
  paramKeys: string[] = [
    AGE_GATE_QUERY_KEY,
    DRAFT_QUERY_KEY,
    SELECT_STORE_QUERY_KEY,
    STORE_ID_QUERY_KEY,
  ]
) {
  const searchParams = new URL(request.url).searchParams;
  return queryStringContaining({ paramKeys, searchParams });
}
